import React from 'react';

export const WellnessIcon = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_581_432)">
                <path
                    d="M12 11.5C12 11.776 11.7765 12 11.5 12H0.5C0.2235 12 0 11.776 0 11.5C0 11.224 0.2235 11 0.5 11H11.5C11.7765 11 12 11.224 12 11.5ZM1.5 9V6H1C0.7235 6 0.5 5.776 0.5 5.5C0.5 5.224 0.7235 5 1 5H1.528C1.7595 2.9175 3.4175 1.259 5.5 1.028V0.5C5.5 0.224 5.7235 0 6 0C6.2765 0 6.5 0.224 6.5 0.5V1.028C8.5825 1.2595 10.241 2.9175 10.472 5H11C11.2765 5 11.5 5.224 11.5 5.5C11.5 5.776 11.2765 6 11 6H10.5V9H11C11.2765 9 11.5 9.224 11.5 9.5C11.5 9.776 11.2765 10 11 10H1C0.7235 10 0.5 9.776 0.5 9.5C0.5 9.224 0.7235 9 1 9H1.5ZM5 6V9H7V6H5ZM9.5 9V6H8V9H9.5ZM2.5 9H4V6H2.5V9Z"
                    fill="currentColor"/>
            </g>
            <defs>
                <clipPath id="clip0_581_432">
                    <rect width="12" height="12" fill="white"/>
                </clipPath>
            </defs>
        </svg>

    )
}